module.exports = __webpack_public_path__ + "img/editPen.0b1ba6ba.svg";